
import { TranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'
import { languageOptions } from 'BrokerTsLib/src/enums'
import React from 'react'

interface TranslationsProviderProps {
    children?: React.ReactNode
}

export const TranslationsProvider = ({ children }: TranslationsProviderProps) => {
    return (
        <TranslationsContext.Provider value={
            {
                translations: {},
                translate: (key: string, defaultValue?: string) => defaultValue ?? key,
                reload: () => { },
                getLanguage: () => languageOptions[0],
                translateFormat: (key: string, defaultValue: string, params?: Record<string, React.ReactNode>) => defaultValue ?? key,
            }
        }>
            {children && children}
        </TranslationsContext.Provider>
    )
}